import React from "react";
import { Icon, Card, Button, Label, Popup } from "semantic-ui-react";
import { getFullName } from "utils/displayName";
import { getWaitingTime } from "utils/dateUtils";

import moment from "moment";

const getRibbonColor = (folderHelp) => {
	switch (folderHelp.status) {
		case "NEW":
			return "yellow";
		case "SUPPORT":
			return "green";
		case "REASSIGNED":
			return "green";
		case "DONE":
			return "white";
		case "ASSIGNED":
			return "orange";
		case "PENDING":
			return "orange";
		case "CANCELED":
			return "grey";
		case "CANCELEDBYSEC":
			return "grey";
		default:
			break;
	}
};
const getRibbonColorNurse = (folderHelp) => {
	switch (folderHelp.status) {
		case "INIT":
			return "black";
		case "NEW":
			return "yellow";
		case "SUPPORT":
			return "orange";
		case "REASSIGNED":
			return "green";
		case "DONE":
			return "black";
		case "ASSIGNED":
			return "orange";
		case "PENDING":
			return "orange";
		case "CANCELED":
			return "grey";
		case "CANCELEDBYSEC":
			return "grey";
		default:
			break;
	}
};

const getRibbonTextNurse = (folderHelp) => {
	switch (folderHelp.status) {
		case "INIT":
			return "En attente du document scanné";
		case "NEW":
			return "En attente";
		case "SUPPORT":
			return `En cours de traitement par ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;
		case "REASSIGNED":
			return "Prêt";
		case "DONE":
			return "Terminé";
		case "ASSIGNED":
			return `Assigné à ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;
		case "PENDING":
			return "En attente d'un.e secrétaire senior";
		case "CANCELED":
			return "Annulé";
		case "CANCELEDBYSEC":
			return "Annulé par une secrétaire";
		default:
			break;
	}
};

const getRibbonText = (folderHelp) => {
	switch (folderHelp.status) {
		case "NEW":
			return "En attente";
		case "SUPPORT":
			return `Vous traitez ce dossier`;
		case "REASSIGNED":
			return "Prêt";
		case "DONE":
			return "Terminé";
		case "ASSIGNED":
			return `Ce dossier vous est assigné`;
		case "PENDING":
			return "En attente d'un.e secrétaire senior";
		case "CANCELED":
			return "Annulé";
		case "CANCELEDBYSEC":
			return "Annulé par une secrétaire";
		default:
			break;
	}
};

export const HelpFolderDropDownItem = ({ folderHelp, isNurse, open, openAndDone, cancel, support, user }) => {
	return (
		<Card key={folderHelp.id} style={{ width: "312px" }}>
			<Label as="span" color={isNurse ? getRibbonColorNurse(folderHelp) : getRibbonColor(folderHelp)} ribbon>
				{isNurse ? getRibbonTextNurse(folderHelp) : getRibbonText(folderHelp)}{" "}
				{isNurse && folderHelp.assigned_to?.myTelForTvSec && (
					<Popup
						trigger={
							<Label
								circular
								color="blue"
								size="mini"
								onClick={() => window.open(`tel:${folderHelp.assigned_to?.myTelForTvSec}`)}
								style={{ cursor: "pointer", margin: "2px 2px 3px 1px" }}
							>
								<Icon name="call" style={{ margin: "0 !important" }} />
							</Label>
						}
						content="Appeler"
					/>
				)}
			</Label>
			{folderHelp.fromPreregister && (
				<Label as="span" color="violet" ribbon>
					Pré-inscription
				</Label>
			)}
			{isNurse && folderHelp.waitingListPlace && (
				<Label as="span" ribbon>
					File d'attente : {folderHelp.waitingListPlace} / {folderHelp.waitingListTotal}
				</Label>
			)}
			{user && folderHelp.created_by && folderHelp.created_by.id !== user.id && (
				<Label as="span" ribbon color="pink">
					Demandé par : {` ${folderHelp.created_by.first_name} ${folderHelp.created_by.last_name}`}
					{folderHelp.folder && folderHelp.folder.labAppointment && folderHelp.folder.labAppointment?.center && (
						<span> {folderHelp.folder?.labAppointment?.center.name}</span>
					)}
				</Label>
			)}

			<Card.Content>
				<Card.Header style={{ fontSize: "1em" }}>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						{getFullName(folderHelp.folder.patient)}{" "}
						{folderHelp.dataPatient && (
							<Label color="brown" size="tiny">
								<Icon name="hand point right" />
								Données patient
							</Label>
						)}
					</div>

					<div>Dossier {folderHelp.folder.code} </div>
					<div>
						<Icon name="wait" /> {getWaitingTime(folderHelp.created_at)}
						{!isNurse && (
							<Card.Meta style={{ fontSize: "9px " }}>
								Créé {folderHelp.created_by ? `par ${folderHelp.created_by.first_name} ${folderHelp.created_by.last_name}` : ""}{" "}
								{moment(folderHelp.created_at) < moment().startOf("day") ? "le " + moment(folderHelp.created_at).format("DD/MM") : ""} à{" "}
								{moment(folderHelp.created_at).format("HH:mm")}
							</Card.Meta>
						)}
					</div>
				</Card.Header>

				<Card.Description style={{ maxHeight: "100px", overflowX: "auto" }}>
					{folderHelp.comments
						.slice()
						.sort((a, b) => moment(b.created_at) - moment(a.created_at))
						.map((c) => (
							<div key={`comment-${c.id}`} style={{ boxShadow: "-2px 2px 0px whitesmoke", margin: "6px 0" }}>
								<div style={{ fontSize: "0.8em", paddingRight: "5px", margin: "-6px 0" }}>
									<Icon name="comments outline" /> {c.created_by ? c.created_by.first_name : ""} {c.created_by ? c.created_by.last_name : ""}{" "}
									<span style={{ fontSize: "10px ", paddingLeft: "5px" }}>
										{moment(c.created_at) < moment().startOf("day") ? "le " + moment(c.created_at).format("DD/MM") : ""} à{" "}
										{moment(c.created_at).format("HH:mm")}
									</span>
								</div>
								<div style={{ fontSize: "0.8em", padding: "4px", whiteSpace: "break-spaces" }}>
									{c.cancellation && c.cancelReason && <Label tag>Annulation de la demande : {c.cancelReason.label}</Label>}
									<strong>{c.comment}</strong>{" "}
								</div>
							</div>
						))}
				</Card.Description>
			</Card.Content>
			{isNurse &&
				(folderHelp.status === "NEW" || folderHelp.status === "PENDING" || folderHelp.status === "INIT") &&
				cancel &&
				!folderHelp.folder.preregister && (
					<Card.Content extra>
						<div className="ui two buttons">
							<Button
								basic
								color="red"
								onClick={(e) => {
									cancel(folderHelp);
								}}
							>
								Annuler cette demande
							</Button>
						</div>
					</Card.Content>
				)}
			{isNurse &&
				(folderHelp.status === "NEW" || folderHelp.status === "PENDING" || folderHelp.status === "INIT") &&
				folderHelp.folder.preregister && (
					<Card.Content extra>
						<div className="ui two buttons">
							<Button
								basic
								color="blue"
								onClick={(e) => {
									open(folderHelp);
								}}
							>
								Voir les infos
							</Button>
						</div>
					</Card.Content>
				)}
			{
				// @see NURSE-290 Make sure this button is not available when preregistration folder is temporary
				isNurse && folderHelp.status === "REASSIGNED" && (!folderHelp.folder.preregister || !folderHelp.folder.is_temp) && (
				<Card.Content extra>
					<div className="ui two buttons">
						<Button basic color="green" onClick={(e) => openAndDone(folderHelp)}>
							Ouvrir le dossier pour prélever
						</Button>
					</div>
				</Card.Content>
			)}
			{
				// @see NURSE-290 Make sure this button is available only for temporary preregistration folder
				isNurse && folderHelp.status === "REASSIGNED" && !!folderHelp.folder.preregister && !!folderHelp.folder.is_temp && (
				<Card.Content extra>
					<div className="ui two buttons">
						<Button basic color="green" onClick={(e) => {
							open(folderHelp);
						}}>
							Ouvrir la préinscription
						</Button>
					</div>
				</Card.Content>
			)}
			{!isNurse && folderHelp.status === "ASSIGNED" && (
				<Card.Content extra>
					<div className="ui two buttons">
						<Button basic color="green" onClick={(e) => support(folderHelp)}>
							Prendre en charge
						</Button>
					</div>
				</Card.Content>
			)}
			{!isNurse && folderHelp.status === "SUPPORT" && (
				<Card.Content extra>
					<div className="ui two buttons">
						<Button basic color="green" onClick={(e) => open(folderHelp)}>
							Ouvrir
						</Button>
					</div>
				</Card.Content>
			)}
			{isNurse && folderHelp.status === "CANCELEDBYSEC" && (
				<Card.Content extra>
					<div className="ui two buttons">
						<Button basic color="green" onClick={(e) => open(folderHelp)}>
							Ouvrir
						</Button>
					</div>
				</Card.Content>
			)}
		</Card>
	);
};
